import { render, staticRenderFns } from "./DateRangeSelectorForCalculator.vue?vue&type=template&id=48287b2c&scoped=true&"
import script from "./DateRangeSelectorForCalculator.vue?vue&type=script&lang=js&"
export * from "./DateRangeSelectorForCalculator.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeSelectorForCalculator.vue?vue&type=style&index=0&id=48287b2c&prod&lang=scss&scoped=true&"
import style1 from "./DateRangeSelectorForCalculator.vue?vue&type=style&index=1&id=48287b2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48287b2c",
  null
  
)

/* custom blocks */
import block0 from "./DateRangeSelectorForCalculator.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./DateRangeSelectorForCalculator.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QBtnDropdown,QCard,QCardSection,QSelect,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnDropdown,QCard,QCardSection,QSelect,QCardActions,QBtn})
